import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import Aos from "aos";

function NewLogin() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  return (
    <div className="main-div">
      <Navbar />
      <div className="flex xl:flex-row justify-between overflow-hidden xl:gap-[90px] gap-[60px] flex-col-reverse xl:py-[180px] py-[70px]">
        <div className="md:pl-[110px] max-w-[654px] w-full pl-[0px] sm:pr-[20px] relative">
          <div className="absolute w-[198px] h-[33px] bg-[#6953A3] top-[186px] left-[-84px]"></div>
          <div className="absolute w-[198px] h-[33px] bg-[#FDD60D] top-[325px] left-[-84px]"></div>
          <div className="bg-[#FFFFFF] overflow-hidden border-[6px] md:max-w-[544px] max-w-[372px] w-full mx-auto relative z-20 border-[#6953A3] rounded-[20px] p-[40px]">
            <h6 data-aos="fade-right" className="sans font-[500] text-[24px] leading-[32px] text-[#0D0D0D] pb-[40px]">
              Leave Us Your Info.
            </h6>
            <div className="flex flex-col gap-[16px]">
              <input
              data-aos="fade-left"
                type="text"
                placeholder="Your Name"
                className="bg-[#FCFCFC] border border-[#D6D6D6] rounded-[8px] py-[12px] px-[20px]"
              />
              <input
              data-aos="fade-right"
                type="email"
                placeholder="Email Address"
                className="bg-[#FCFCFC] border border-[#D6D6D6] rounded-[8px] py-[12px] px-[20px]"
              />
              <textarea
                name=""
                id=""
                data-aos="fade-left"
                placeholder="Comment"
                className="bg-[#FCFCFC] border border-[#D6D6D6] rounded-[8px] py-[12px] px-[20px]"
                cols="30"
                rows="4"
              ></textarea>
              <div data-aos="fade-right" className="flex items-center gap-[12px]">
                <input type="checkbox" name="" id="" />
                <p className="font-[400] md:text-[14px] text-[12px] leading-[20px] text-[#808080]">
                  You agree to our friendly{" "}
                  <span className="text-[#6953A3] font-[600]">
                    {" "}
                    privacy policy.
                  </span>
                </p>
              </div>
              <div data-aos="fade-left" className="pt-[24px]">
                <button className="btn" style={{width: "auto"}}>
                  Send Message <span className="arrow"></span>
                </button>
              </div>
            </div>
          </div>
          <div data-aos="flip-up" className="flex pt-[45px] items-center gap-[24px]">
            <p className="sans font-[500] text-[24px] leading-[32px] text-[#0D0D0D]">
              Follow Us :
            </p>
            <div className="flex gap-[15px]">
              <a href="https://www.facebook.com/people/GisulCommunity/61576707204734/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/Facebook.svg" alt="" />
              </a>
              <a href="https://www.instagram.com/gisulcommunity/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/Instagram.svg" alt="" />
              </a>
              <a href="https://x.com/gisulcommunity" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/Twitter.svg" alt="" />
              </a>
              <a href="https://www.linkedin.com/company/gisuledtech" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/Linkedin.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col overflow-hidden gap-[26px]">
          <div className="flex bg-[#6953A3] items-center md:gap-[30px] gap-[10px] md:h-[303px] h-[171px] md:max-w-[697px] max-w-[392px] w-full ml-auto rounded-l-full md:pl-[26px] pl-[15px]">
            <img data-aos="fade-right"
              src="/assets/footer/icon7.svg"
              className="md:h-[330px] h-[216px] md:w-[229px] w-[141px] object-cover"
              alt=""
            />
            <h6 data-aos="fade-left" className="sans-text font-[400] italic md:text-[110px] text-[60px] md:leading-[110px] leading-[60px] text-[#F1E60D]">
              Contact Us
            </h6>
          </div>
          <div className="flex flex-col md:gap-[32px] gap-[12px] bg-[#FDD60D] md:h-[303px] h-[171px] md:max-w-[697px] max-w-[392px] w-full ml-auto rounded-l-full md:pl-[100px] pl-[60px] md:pt-[33px] pt-[11px]">
            <div data-aos="fade-left" className="flex items-center md:gap-[16px] gap-[12px]">
              <img src="/assets/footer/lnk1.svg" className="md:h-[44px] h-[33px]" alt="" />
              <div>
                <h6 className="sans text-[#0D0D0D] font-[500] md:text-[20px] text-[16px] md:leading-[30px] md:pb-[4px]">
                  Address
                </h6>
                <p className="sand text-[#808080] font-[400] md:text-[16px] text-[13px] md:leading-[24px]">
                  403, Port Washington Road, Canada.
                </p>
              </div>
            </div>
            <div data-aos="flip-up" className="flex items-center md:gap-[16px] gap-[12px]">
              <img src="/assets/footer/link3.svg" className="md:h-[44px] h-[33px]" alt="" />
              <div>
                <h6 className="sans text-[#0D0D0D] font-[500] md:text-[20px] text-[16px] md:leading-[30px] md:pb-[4px]">
                  Contact Details
                </h6>
                <p className="sand text-[#808080] font-[400] md:text-[16px] text-[13px] md:leading-[24px]">
                  +1 800-525-54-589
                </p>
              </div>
            </div>
            <div data-aos="fade-right" className="flex items-center md:gap-[16px] gap-[12px]">
              <img src="/assets/footer/link2.svg" className="md:h-[44px] h-[33px]" alt="" />
              <div>
                <h6 className="sans text-[#0D0D0D] font-[500] md:text-[20px] text-[16px] md:leading-[30px] md:pb-[4px]">
                  Email Us
                </h6>
                <p className="sand text-[#808080] font-[400] md:text-[16px] text-[13px] md:leading-[24px]">
                  info@wdesignkit.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 
      <div className="New-login">
        <div className="New-login-left">
          <div className="b1">
            <h2>Have Your Own</h2>
          </div>
          <br />
          <div className="b2">
            <h2>Account With Us</h2>
          </div>
          <br />
          <div className="Register-div">
            <p>If you don’t have an account register</p>
            <p>
              You can{" "}
              <Link to="/login" style={{ color: "blueviolet" }}>
                {" "}
                Register here !{" "}
              </Link>{" "}
              !!
            </p>
            <br />
            <div className="cnt">
              <img src={img} />
            </div>
          </div>
        </div>

        <div className="New-login-right">
          <div className="login-form">
            <div className="login-heading">
              <p>Welcome to GISUL</p>
              <h6>
                Have an Account ?<br />
                <Link to="/singup" style={{ color: "#075D9D" }}>
                  Sign up
                </Link>
              </h6>
            </div>
            <h3>Log in</h3>
            <div className="ips">
              <br />
              <label>Enter your username or email address</label>
              <input />

              <br />

              <label>Enter your Password</label>
              <input />
            </div>
            <br />

            <p>Forget Password</p>

            <br />
            <button>Login</button>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
}

export default NewLogin;
